import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ContactForm from "@/pages/about/components/ContactForm";
import { usePageMeta } from "@/hooks/usePageMeta";

const services = [
  {
    icon: "ri-newspaper-line",
    title: "影视资讯聚合",
    desc: "每日汇集最新电影、电视剧资讯与行业动态，第一时间掌握上映与开播信息。",
  },
  {
    icon: "ri-star-smile-line",
    title: "评分与推荐",
    desc: "整理编辑推荐指数与口碑参考，按类型、地区、年份多维筛选，帮你快速做决定。",
  },
  {
    icon: "ri-book-open-line",
    title: "作品资料库",
    desc: "覆盖剧情概要、主创阵容、上映信息等完整资料，深入了解每一部优质作品。",
  },
];

const contactItems = [
  { icon: "ri-map-pin-line", label: "公司地址", value: "上海市浦东新区影创路 88 号" },
  { icon: "ri-mail-line", label: "商务合作", value: "contact@kekefilm.example.com" },
  { icon: "ri-customer-service-2-line", label: "客服热线", value: "400-000-0000" },
  { icon: "ri-time-line", label: "服务时间", value: "周一至周五 9:00 - 18:00" },
];

export default function About() {
  usePageMeta({
    title: "关于我们 - 可可影视",
    description:
      "可可影视是专业影视资讯平台，提供电影电视剧资讯、影视作品评分推荐与完整资料，帮助影视爱好者轻松发现优质影视资源。欢迎联系我们。",
    keywords: "关于可可影视,影视资讯平台,联系我们,影视评分推荐",
    canonical: "https://hbsfkj.cn/about",
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <section className="w-full border-b border-background-200/80 bg-background-100 px-4 py-12 md:px-8 md:py-16">
          <div className="max-w-3xl">
            <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于" }]} />
            <h1 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              关于可可影视
            </h1>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              可可影视是一个聚焦专业影视资讯与内容展示的平台，面向喜爱影视内容、追踪影视动态的普通观众与影评爱好者。
              我们汇聚最新电影、电视剧资讯，提供影视作品评分推荐与详情介绍，帮助每一位用户
              <b className="font-semibold text-foreground-900">轻松发现和了解优质影视作品</b>，
              满足及时获取影视资讯与深入了解影视资料的双重需求。
            </p>
          </div>
        </section>

        <section className="w-full px-4 py-12 md:px-8 md:py-16">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">我们提供什么</h2>
          <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
            {services.map((service) => (
              <div
                key={service.title}
                className="rounded-lg border border-background-200/80 bg-background-100 p-6"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-2xl text-primary-700">
                  <i className={service.icon}></i>
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{service.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-500">{service.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="w-full bg-background-100 px-4 py-12 md:px-8 md:py-16">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
            <div>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                联系方式
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                有任何影视资讯合作、内容反馈或使用建议，欢迎通过以下方式与我们取得联系。
              </p>
              <ul className="mt-6 flex flex-col gap-4">
                {contactItems.map((item) => (
                  <li key={item.label} className="flex items-start gap-3">
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-background-50 text-lg text-accent-600">
                      <i className={item.icon}></i>
                    </span>
                    <span className="flex flex-col">
                      <span className="text-xs text-foreground-400">{item.label}</span>
                      <span className="text-sm font-medium text-foreground-900">{item.value}</span>
                    </span>
                  </li>
                ))}
              </ul>

              <div className="mt-6 h-52 w-full overflow-hidden rounded-lg border border-background-200/80">
                <iframe
                  title="可可影视办公地点地图"
                  src="https://www.google.com/maps?q=Shanghai%20Pudong&output=embed"
                  className="h-full w-full"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                在线留言
              </h2>
              <p className="mt-3 mb-6 text-sm leading-relaxed text-foreground-600">
                填写下面的表单，我们会尽快回复你。
              </p>
              <ContactForm />
            </div>
          </div>
        </section>

        <section className="w-full px-4 py-12 md:px-8 md:py-14">
          <div className="rounded-lg border border-background-200/80 bg-background-50 p-6 md:p-8">
            <h2 className="font-heading text-xl font-bold text-foreground-950">版权信息与声明</h2>
            <div className="mt-4 flex flex-col gap-3 text-sm leading-relaxed text-foreground-600">
              <p>
                本站所有影视作品名称、简介、评分与相关图片均为演示内容，仅用于平台功能展示，
                不构成任何实际影视作品的官方信息或观看引导。
              </p>
              <p>
                可可影视尊重知识产权，如本站展示内容涉及相关权益，请通过上方联系方式与我们沟通处理。
                未经许可，任何单位或个人不得以任何形式复制、转载本站内容用于商业用途。
              </p>
              <p>© 2026 可可影视 KekeFilm. 保留所有权利。</p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}